import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './LeaderboardAdsSlider.css';

/**
 * Figma 20908:2489 — 570×855 rounded poster slider.
 * Slides come from tournamentRewardImagesArray.
 */
const LeaderboardAdsSlider = ({
  banners = [],
  autoPlay = true,
  intervalMs = 4000,
}) => {
  const slides = (Array.isArray(banners) ? banners : [])
    .map((item, index) => ({
      id: item.id || `reward-${item.order ?? index}`,
      src: item.src || item.image || '',
      alt: item.alt || `Tournament reward ${item.order ?? index + 1}`,
      url: item.url || '',
    }))
    .filter((slide) => slide.src);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!autoPlay || slides.length < 2) return undefined;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, intervalMs);
    return () => clearInterval(timer);
  }, [autoPlay, slides.length, intervalMs]);

  useEffect(() => {
    setIndex(0);
  }, [slides.length]);

  if (!slides.length) return null;

  return (
    <aside
      className="lb-ads"
      data-node-id="20908:2489"
      data-name="Background"
      aria-label="Advertisement"
    >
      {slides.map((slide, slideIndex) => {
        const isActive = slideIndex === index;
        const image = (
          <img
            className="lb-ads__image"
            src={slide.src}
            alt={slide.alt}
            draggable={false}
          />
        );
        return (
          <div
            key={slide.id}
            className={`lb-ads__slide${isActive ? ' is-active' : ''}`}
            aria-hidden={!isActive}
          >
            {slide.url ? (
              <a
                href={slide.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={slide.alt}
              >
                {image}
              </a>
            ) : (
              image
            )}
          </div>
        );
      })}
      {slides.length > 1 ? (
        <div className="lb-ads__indicators" aria-label="Advertisement slides">
          {slides.map((slide, slideIndex) => (
            <button
              key={`dot-${slide.id}`}
              type="button"
              className={`lb-ads__dot${slideIndex === index ? ' is-active' : ''}`}
              onClick={() => setIndex(slideIndex)}
              aria-label={`Show ad ${slideIndex + 1}`}
              aria-current={slideIndex === index ? 'true' : undefined}
            />
          ))}
        </div>
      ) : null}
    </aside>
  );
};

LeaderboardAdsSlider.propTypes = {
  banners: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      src: PropTypes.string,
      image: PropTypes.string,
      alt: PropTypes.string,
      url: PropTypes.string,
      order: PropTypes.number,
    })
  ),
  autoPlay: PropTypes.bool,
  intervalMs: PropTypes.number,
};

export default LeaderboardAdsSlider;
